export class AdditionalFilter {
    searchQuery: string[];
    SortKey: string | null;
    IsDesc: boolean | true;
    TakeCount: number;
    SkipCount: number;
    TotalItems: number;

    constructor() {
        this.searchQuery = [];
        this.SortKey = null;
        this.IsDesc = true;
        this.TakeCount = 0;
        this.SkipCount = 0;
        this.TotalItems = 0;
    }
}